"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verticalCenterStyle = void 0;
// https://github.com/reactjs/react-modal/issues/62
exports.verticalCenterStyle = {
    minHeight: '10rem',
    left: '50%',
    position: 'fixed',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    minWidth: '20rem',
    bottom: "initial"
};
//# sourceMappingURL=react-modal-utilities.js.map